import type { ItineraryTravelMode$options } from '$houdini';
import * as m from '$paraglide/messages';

const travelModeLabel: Record<ItineraryTravelMode$options, () => string> = {
	CAR: m.itinerary__options__modes__car,
	MOTORCYCLE: m.itinerary__options__modes__motorcycle,
	BIKE: m.itinerary__options__modes__bike,
	WALK: m.itinerary__options__modes__walk,
};
export function travelModes(mode: ItineraryTravelMode$options): string {
	return travelModeLabel[mode]();
}
